import React from "react";
import {
  Grid,
  makeStyles,
  Typography,
  Paper,
  Button,
} from "@material-ui/core";
import { ValidatorForm, TextValidator } from "react-material-ui-form-validator";
import useError from "Hooks/useError";
import MuiAlert from "@material-ui/lab/Alert";
import { message } from "constants/message";

const useStyles = makeStyles((theme) => ({
  paper: {
    padding: theme.spacing(2),
    display: "flex",
    overflow: "auto",
    flexDirection: "column",
  },
  wrapper: {
    marginTop: theme.spacing(2),
  },
  counter: {
    marginTop: theme.spacing(1),
    fontSize: "0.85rem",
    color: "rgba(0, 0, 0, 0.54)",
    textAlign: "right",
  },
  messsageWrapper: {
    marginTop: theme.spacing(1),
  },
}));

export default function Form({ submit, collectionTheme = null, isEdit = false }) {
  const classes = useStyles();
  const stateError = useError();
  const messages = message();

  const [themeName, setThemeName] = React.useState("");
  const [summary, setSummary] = React.useState("");
  const [keywords, setKeywords] = React.useState("");

  // キーワードの行数カウント（空行は除外）
  const keywordCount = keywords
    .split("\n")
    .map((line) => line.trim())
    .filter((line) => line.length > 0).length;

  React.useEffect(() => {
    stateError.initialize();
  }, []);

  React.useEffect(() => {
    if (!collectionTheme) return;
    setThemeName(collectionTheme.themeName);
    setSummary(collectionTheme.summary);
    setKeywords(collectionTheme.keywords);
  }, [collectionTheme]);

  const onError = () => {
    stateError.dispatch({
      type: "set",
      payload: {
        isError: true,
        errorMsg: messages.validation.common,
      },
    });
  };

  return (
    <Grid>
      <ValidatorForm
        onSubmit={(e) => {
          e.preventDefault();
          submit({ themeName, summary, keywords });
        }}
        onError={onError}
      >
        <Paper elevation={3} className={classes.paper}>
          <Typography variant="h6" color="primary">
            {isEdit ? "絞り込みテーマ更新" : "絞り込みテーマ登録"}
          </Typography>
          <Grid container>
            <Grid item xs={12} className={classes.wrapper}>
              <TextValidator
                data-testid="collectionThemeForm-themeName"
                label="テーマ名*"
                fullWidth
                value={themeName}
                onChange={(event) => setThemeName(event.target.value)}
                type="text"
                validators={["required"]}
                errorMessages={[messages.validation.required]}
              />
            </Grid>
            <Grid item xs={12} className={classes.wrapper}>
              <TextValidator
                data-testid="collectionThemeForm-summary"
                label="概要*"
                fullWidth
                value={summary}
                onChange={(event) => setSummary(event.target.value)}
                type="text"
                validators={["required"]}
                errorMessages={[messages.validation.required]}
              />
            </Grid>
            <Grid item xs={12} className={classes.wrapper}>
              <TextValidator
                data-testid="collectionThemeForm-keywords"
                label="絞り込みキーワード*"
                fullWidth
                multiline
                minRows={6}
                value={keywords}
                onChange={(event) => setKeywords(event.target.value)}
                type="text"
                validators={["required"]}
                errorMessages={[messages.validation.required]}
                helperText="1行に1キーワードで入力してください"
              />
              <div className={classes.counter} data-testid="collectionThemeForm-keywordCount">
                絞り込みキーワード数: {keywordCount}
              </div>
            </Grid>
          </Grid>
        </Paper>
        {stateError.state.isError && (
          <div className={classes.messsageWrapper} data-testid="collectionThemeForm-errorMessage">
            <MuiAlert
              elevation={6}
              variant="filled"
              severity="error"
            >
              {stateError.state.errorMsg}
            </MuiAlert>
          </div>
        )}
        <Grid container justifyContent="center" className={classes.wrapper}>
          <Button type="submit" variant="contained" color="primary" data-testid="collectionThemeForm-submitButton">
            {isEdit ? "更新" : "登録"}
          </Button>
        </Grid>
      </ValidatorForm>
    </Grid>
  );
}
